<!-- Component is expected to be inside a pane -->
@if (conf$ | async; as conf) {
  <elder-pane-content class="full p-0">
    <elder-pane-subtitle start>{{ 'context.details' | translate }}</elder-pane-subtitle>
    <div class="layout-row place-start-center gap-md">
      <mat-form-field>
        <mat-label>{{ 'context.description' | translate }}</mat-label>
        <input
          matInput
          name="description"
          type="text"
          required
          placeholder="{{ 'context.description' | translate }}"
          [(ngModel)]="conf.description"
          #nameModel="ngModel"
        />
        <mat-error elderValidationError></mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'context.specification' | translate }}</mat-label>
        <input
          matInput
          name="specId"
          type="text"
          readonly
          placeholder="{{ 'context.specification' | translate }}"
          [ngModel]="conf?.spec?.name"
        />
        <mat-error elderValidationError></mat-error>
      </mat-form-field>
    </div>
    <mat-tab-group class="flex" animationDuration="0ms">
      <!-- Tab conditions -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="conf?.conditions?.length"
            [matBadgeHidden]="!conf?.conditions?.length"
            [matBadgeOverlap]="false"
            >{{ 'skillSets.conditions.title' | translate }}
          </span>
        </ng-template>
        <app-constraints-table class="flex" [name]="'conditions'" [constraints]="conf.conditions">
        </app-constraints-table>
      </mat-tab>
      <!-- Tab Properties -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="conf?.properties?.length"
            [matBadgeHidden]="!conf?.properties?.length"
            [matBadgeOverlap]="false"
            >{{ 'properties.title' | translate }}
          </span>
        </ng-template>
        <app-property-conf-table class="flex" [name]="'properties'" [properties]="conf.properties">
        </app-property-conf-table>
      </mat-tab>
    </mat-tab-group>
  </elder-pane-content>
}
